/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Settings in the Stammdaten service
 */
export enum EnumStammdatenSettings {
    /**
     * No setting
     */
    NotDefined = 0,
    /**
     * Indicates that the debtor number in an address should equal the address number.
     */
    DebtorNumberEqualsAddress = 1,
    /**
     * Indicates that the creditor number in an address should equal the address number.
     */
    CreditorNumberEqualsAddress = 2,
    /**
     * Indicates that the Invoice document printout has the order printout as attachment
     */
    InvoiceHasOrderAttachment = 3,
    /**
     * Indicates that the Invoice document printout has the weighing slip printout as attachment
     */
    InvoiceHasWeighingSlipAttachment = 4,
    /**
     * Default payment term for expenses
     */
    PaymentTermsForExpenses = 5,
    /**
     * Default payment term for incoming transfers
     */
    PaymentTermsForRevenue = 6,
    /**
     * Default payment term for cash payments
     */
    PaymentTermsForCashPayment = 7,
}
